module.exports = __webpack_public_path__ + "img/1F92F.8a55196e.svg";